import api from "./api";

export interface FolhaServicoDto {
  id: number;
  nome: string;
  valorUnitario: number;
  createdAt: string;
  updatedAt: string;
}

export interface FolhaServicoFormValues {
  nome: string;
  valorUnitario: number;
}

const BASE_URL = "/api/folha-pagamentos/servicos";

export async function listFolhaServicos(): Promise<FolhaServicoDto[]> {
  const { data } = await api.get<{ success: boolean; servicos: FolhaServicoDto[] }>(BASE_URL);
  return data.servicos;
}

export async function createFolhaServico(
  values: FolhaServicoFormValues,
): Promise<FolhaServicoDto> {
  const { data } = await api.post<{ success: boolean; servico: FolhaServicoDto }>(BASE_URL, values);
  return data.servico;
}

export async function updateFolhaServico(
  id: number,
  values: Partial<FolhaServicoFormValues>,
): Promise<FolhaServicoDto> {
  const { data } = await api.patch<{ success: boolean; servico: FolhaServicoDto }>(
    `${BASE_URL}/${encodeURIComponent(String(id))}`,
    values,
  );
  return data.servico;
}

export async function deleteFolhaServico(id: number): Promise<void> {
  await api.delete(`${BASE_URL}/${encodeURIComponent(String(id))}`);
}
